import React, { useEffect } from "react";
import DateFormat from "./DateFormat";
import "@arcgis/map-components/components/arcgis-map";
import esriConfig from "@arcgis/core/config.js";
import Graphic from "@arcgis/core/Graphic.js";
//import has from "lodash/has";
import get from "lodash/get";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";

const DeviceChecks = ({
  tags,
  fileName,
  latitudeField,
  longitudeField,
  dateField,
  timeField,
  dateTimeField,
  dateTimeFormat,
  setGpsGood,
  setDateGood,
}) => {
  esriConfig.portalUrl = "https://gis.thompsoncs.net/arcgis";
  const latitude = get(tags, latitudeField) || 0;
  const longitude = get(tags, longitudeField) || 0;
  //const [point, setPoint] = useState({ type: "point", x: 0, y: 0 });

  useEffect(() => {
    const makeMap = async () => {
      const viewElement = document.querySelector("arcgis-map");
      const graphicsLayer = new GraphicsLayer();
      await viewElement.viewOnReady();
      viewElement.map.add(graphicsLayer);

      const markerSymbol = {
        type: "simple-marker",
        color: [248, 153, 28],
        outline: {
          color: [255, 255, 255],
          width: 2,
        },
      };

      const pointGraphic = new Graphic({
        geometry: { type: "point", x: longitude, y: latitude },
        symbol: markerSymbol,
      });

      graphicsLayer.add(pointGraphic);

      viewElement.goTo({ target: [longitude, latitude], zoom: 16 });
    };
    if (latitude && longitude) {
      makeMap();
    }

    if (
      latitude >= -90 &&
      latitude <= 90 &&
      longitude >= -180 &&
      longitude <= 180
    ) {
      setGpsGood(true);
    }
  }, [latitude, longitude, setGpsGood]);

  return (
    <>
      <arcgis-map
        item-id="cc93f41af383470594965e115c754a8c"
        style={{ height: "400px" }}
      ></arcgis-map>

      <DateFormat
        tags={tags}
        fileName={fileName}
        dateField={dateField}
        timeField={timeField}
        dateTimeField={dateTimeField}
        dateTimeFormat={dateTimeFormat}
        setDateGood={setDateGood}
      />
    </>
  );
};

export default DeviceChecks;
